import { createTheme } from "@mui/material/styles";

export const darkTheme = createTheme({
  palette: {
    mode: "dark",
    primary: {
      main: "#4f46e5", // indigo
    },
    secondary: {
      main: "#ec4899", // pink
    },
    background: {
      default: "#020617",
      paper: "#020617",
    },
    divider: "rgba(148,163,184,0.35)",
  },
  typography: {
    fontFamily: [
      "system-ui",
      "-apple-system",
      "BlinkMacSystemFont",
      '"SF Pro Text"',
      "Inter",
      "sans-serif",
    ].join(","),
    h1: { fontWeight: 600, letterSpacing: "-0.04em" },
    h2: { fontWeight: 600, letterSpacing: "-0.03em" },
    h3: { fontWeight: 600, letterSpacing: "-0.02em" },
    body1: { fontSize: 14 },
  },
  shape: {
    borderRadius: 12,
  },
  components: {
    MuiPaper: {
      styleOverrides: {
        root: {
          backgroundImage: "radial-gradient(circle at top left, #0b1120 0, #020617 55%)",
          border: "1px solid rgba(148,163,184,0.35)",
        },
      },
    },
  },
  breakpoints: {
    values: {
      xs: 0,
      sm: 600,
      md: 900,
      lg: 1200,
      xl: 2600,
    }
  }
});
